import * as React from "react";
const SvgLock = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M31 18h-1.5v-4.5C29.5 8.262 25.238 4 20 4s-9.5 4.262-9.5 9.5V18H9a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V21a3 3 0 0 0-3-3Zm-6.5 0h-9v-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5V18Z" }));
export default SvgLock;
